import {post} from './http'
const baseUrl = '/api/capwhale/course/public'

// 收藏
export const uploadCourseFavorite = v => post(`${baseUrl}/uploadCourseFavorite`, v.data, v.success, v.error)